
import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { MapPin, ChevronRight, ChevronLeft } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

export interface ExhibitItemProps {
  id: string;
  numberCode: string;
  titleEn: string;
  titleHe: string;
  image: string;
  location?: {
    floor?: number;
    room?: string;
  } | null;
  tourId: string;
}

export const TourExhibitItem: React.FC<ExhibitItemProps> = ({
  id,
  numberCode,
  titleEn,
  titleHe,
  image,
  location,
  tourId
}) => {
  const { language, dir } = useLanguage();
  const DirectionIcon = dir === 'rtl' ? ChevronLeft : ChevronRight;
  
  // EXTREMELY strict validation - never show dummy/placeholder data
  const hasValidLocation = location && 
    typeof location === 'object' && 
    location.room && 
    typeof location.room === 'string' && 
    location.room.trim() !== '' &&
    // Exclude any dummy/placeholder data patterns
    !location.room.toLowerCase().includes('room 1') &&
    !location.room.toLowerCase().includes('room1') &&
    !location.room.toLowerCase().match(/^room\s*\d+$/i) &&
    location.room !== 'Room 1' && 
    location.room !== 'room 1' &&
    location.room !== 'Room1' &&
    location.room !== 'room1' &&
    typeof location.floor === 'number' &&
    location.floor > 0 &&
    // Don't show floor 1 if it might be dummy data
    !(location.floor === 1 && location.room.toLowerCase().includes('room'));

  console.log('TourExhibitItem location validation:', {
    exhibitId: id,
    rawLocation: location,
    roomValue: location?.room,
    floorValue: location?.floor,
    hasValidLocation: hasValidLocation,
    roomMatchesDummyPattern: location?.room ? location.room.toLowerCase().match(/^room\s*\d+$/i) : false
  });

  return (
    <Link 
      to={`/exhibit/${id}`} 
      state={{ from: `tour-${tourId}` }}
    >
      <Card className="transition-all hover:shadow-md hover:translate-x-1 flex items-center">
        <div className="w-20 h-20 shrink-0 bg-museum-light overflow-hidden">
          <img 
            src={image} 
            alt={language === 'en' ? titleEn : titleHe}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="p-4 flex-grow">
          <div className="flex items-start gap-2">
            <span className="text-lg font-medium text-gray-600 flex-shrink-0">{numberCode}</span>
            <div className="font-bold text-lg whitespace-pre-line leading-tight">
              {language === 'en' ? titleEn : titleHe}
            </div>
          </div>
          {hasValidLocation && (
            <div className="text-sm text-gray-500 flex items-center gap-1 mt-1">
              <MapPin size={14} />
              {language === 'en' ? 'Floor' : 'קומה'} {location.floor}, {location.room}
            </div>
          )}
        </div>
        <div className="pr-4">
          <DirectionIcon className="text-gray-400" />
        </div>
      </Card>
    </Link>
  );
};
